export const GET_EMAIL_TEMPLATE = "HEDGEFUND@GET_EMAIL_TEMPLATE";
export const GET_EMAIL_TEMPLATE_INIT = "HEDGEFUND@GET_EMAIL_TEMPLATE_INIT";
export const GET_EMAIL_TEMPLATE_SUCCESS = "HEDGEFUND@GET_EMAIL_TEMPLATE_SUCCESS";
export const GET_EMAIL_TEMPLATE_FAILED = "HEDGEFUND@GET_EMAIL_TEMPLATE_FAILED";

export const CREATE_USER_PREFERENCE = "HEDGEFUND@CREATE_USER_PREFERENCE";
export const CREATE_USER_PREFERENCE_INIT = "HEDGEFUND@CREATE_USER_PREFERENCE_INIT";
export const CREATE_USER_PREFERENCE_SUCCESS = "HEDGEFUND@CREATE_USER_PREFERENCE_SUCCESS";
export const CREATE_USER_PREFERENCE_FAILED = "HEDGEFUND@CREATE_USER_PREFERENCE_FAILED";
